<template>
  <div class="user no-scrollbar">
    <div class="container has-text-left" style="margin-top: -6px">
      <div class="notification" :style="userStateStyle">
        <div class="field">
          <p class="subtitle">User Lookup - Deprecated</p>
          <div class="control has-icons-left">
            <input
              class="input is-dark"
              type="text"
              :value="userName"
              @focus="clearUser"
              placeholder="Name or mobile"
              @keyup="lookupUsers($event)"
              autocomplete="new-password"
              name="no-suggestion"
            />

            <!-- @blur="passengers=[]" passengerName, clearPassenger, lookupPassengers-->
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
          </div>
          <div class="list" v-if="users.length > 0">
            <span
              v-for="u in users"
              class="list-item single-line no-scrollbar"
              :key="u.key"
              @click="selectUser(u)"
              >{{ u.key }}</span
            >
          </div>
        </div>

        <div class="field has-text-left" v-if="ID && !t">
          <div @click="showMessage = !showMessage">
            <i class="far fa-window-minimize is-pulled-right" />
            <label class="subtitle">Send Message</label>
          </div>
          <div v-show="showMessage">
            <div class="control">
              <textarea
                class="textarea is-primary"
                v-model="message"
                placeholder="Type message here"
                rows="2"
              ></textarea>
            </div>
            <div style="height: 5px" />
            <div class="buttons is-centered">
              <span
                class="button is-rounded has-text-warning"
                style="padding: 5px 10px"
                v-clipboard:copy="message"
                v-clipboard:success="onCopy"
              >
                <i class="fa fa-copy" />
              </span>
              <span
                class="button is-rounded is-link is-outlined round"
                @click="sendMessage('sms')"
                >SMS</span
              >
              <span
                class="button is-rounded is-info is-outlined round"
                @click="sendMessage('push')"
                >Push</span
              >
              <!-- <span class="button is-success is-outlined" @click="callPhone">
              <i class="fa fa-phone" />
              </span>-->
              <span class="button is-rounded round" @click="message = ''">
                <i class="fa fa-times-circle" />
              </span>
              <!-- style="position:absolute; right:18px; margin-top:20px; padding: 5px 9px" -->
              <span class="button is-rounded round">
                <i class="fa fa-magic has-text-info" @click="specialMessages" />
              </span>
            </div>
          </div>
        </div>

        <div class="field has-text-left" v-if="transactions.length > 0 && !t">
          <div @click="showTransactions = !showTransactions">
            <i class="far fa-window-minimize is-pulled-right" />
            <label class="subtitle" @click="getTransactionsForUser"
              >Recent Transactions ({{ transactions.length }})</label
            >
          </div>
          <div v-show="showTransactions" class="list">
            <span
              v-for="t in transactions"
              class="list-item has-text-left single-line"
              :style="backgroundStyle(t)"
              :key="t.id"
              @click="selectTransaction(t)"
            >
              <span class="tag icon is-success" v-if="isDriver(t)">
                <i class="fa fa-shuttle-van" />
              </span>
              <span class="tag icon is-link" v-else>
                <i class="fa fa-user" />
              </span>
              <span class="tag">{{ longScheduledTime(t) }}</span>
              <span class="tag is-dark" :class="stateClass(t)">{{
                t.state
              }}</span>
              <span class="tag">
                <i class="fa fa-shuttle-van" v-if="!isDriver(t)" />
                <i class="fa fa-user" v-else />
                &nbsp;
                {{ otherPartyName(t) }}
              </span>
            </span>
            <span class="list-item" style="background-color: #eee">
              <span @click="getMoreTransactions">
                <span class="icon button is-rounded">
                  <i class="fa fa-chevron-down" />
                </span>
              </span>
              <span
                class="icon button is-rounded is-pulled-right"
                @click="getTransactionsForUser"
              >
                <i class="fa fa-redo" />
              </span>
            </span>
          </div>
        </div>

        <div class="field has-text-left" v-if="roles.length > 0 && !t">
          <div @click="showRoles = !showRoles">
            <!-- <i class="far fa-window-minimize is-pulled-right" /> -->
            <label class="subtitle">Roles ({{ roles.length }})</label>
          </div>
          <div v-show="showRoles" class="list">
            <span
              v-for="r in roles"
              class="list-item"
              :style="roleStyle(r)"
              :key="r.id"
              @click="moreInfo(r)"
            >
              <span class="icon" v-if="r.role_name === 'Driver'">
                <i class="fa fa-shuttle-van" />
              </span>
              <span class="icon" v-else-if="r.role_name === 'Dispatcher'">
                <i class="fa fa-phone" />
              </span>
              <span class="icon" v-else>
                <i class="fa fa-user" />
              </span>
              <span class="tag has-text-weight-semibold">
                <i
                  class="fa fa-spinner fa-spin has-text-success"
                  style="margin-right: 5px"
                  v-if="r.state === 'working'"
                />
                {{ r.role_name }}
              </span>
              <span class="tag is-dark">{{ r.business.name }}</span>
            </span>
          </div>
          <div v-show="showRoles" style="margin-top: -10px">
            <div>
              <label class="subtitle">Payment Details</label>
              <i v-if="!(bankAccounts.length + qrCodes.length)"> - None</i>
            </div>
            <div
              v-for="r in bankAccounts"
              :key="r.id"
              class="bank-transfer"
              @click="copy(r.data.bank_account.account_number)"
            >
              <p style="margin-bottom: 6px; font-weight: 550; opacity: 0.7">
                <i> {{ r.role_name }} - {{ r.business.name }} </i>
              </p>
              <p>{{ r.data.bank_account.bank_name }}</p>
              <p>
                {{ r.data.bank_account.account_number }}
                &nbsp;<i class="fa fa-copy has-text-white" />
              </p>
              <p>
                {{ r.data.bank_account.name_on_account }}
              </p>
            </div>
            <div v-for="r in qrCodes" :key="'q' + r.id" style="margin-top: 9px">
              <img
                class="qr-code"
                :src="r.data.qr_pic_url"
                v-img-fallback="imgFallback"
              />
            </div>
          </div>
        </div>

        <div class="field has-text-left" v-if="user && !t">
          <label class="subtitle">
            User Info
            <span
              v-show="!user.name"
              class="has-text-danger is-pulled-right is-size-6"
              >*Name not set</span
            >
          </label>
          <div class="list">
            <span class="list-item">
              Mobile:
              <span
                class="has-text-link has-text-weight-medium link"
                @click="callPhoneNumber(user.phone_number)"
              >
                {{ user.phone_number }}
              </span>
              <!-- <i class="fa fa-phone has-text-link" /> -->
              <span class="tag is-pulled-right" @click="editMobile">
                Source:&nbsp;
                <strong>{{ user.source.toUpperCase() }}</strong>
              </span>
            </span>
            <span class="list-item">
              Language: {{ $t("language." + user.language) }}
              <span
                v-if="userHasNotifications"
                class="tag is-success is-pulled-right"
              >
                Notifications:
                <strong>ON</strong>
              </span>
              <span v-else class="tag is-danger is-pulled-right">
                Notifications:
                <strong>OFF</strong>
              </span>
            </span>
            <!-- <span
              class="list-item"
              :style="notificationsStyle"
            >Notifications: {{userHasNotifications}}</span>-->
            <span class="list-item">
              Created: {{ userCreatedAt }}
              <span class="tag is-pulled-right">{{
                timeAgo(user.created_at)
              }}</span>
            </span>
            <span class="list-item" @click="updatedAtInfo">
              Updated: {{ userUpdatedAt }}
              <span class="tag is-pulled-right">{{
                timeAgo(user.updated_at)
              }}</span>
            </span>
            <span class="list-item" @click="copyUserID">
              UserID:
              <span class="tag is-info is-pulled-right">{{ user.id }}</span>
            </span>
            <span class="list-item" @click="copyUUID">
              UUID:
              <span class="tag is-primary is-pulled-right">{{
                user.uuid
              }}</span>
            </span>
          </div>
          <div style="margin-top: -15px; border-radius: 5px">
            <img :src="user.profile_pic_url || fallbackProfPic()" />
            <div class="is-pulled-right">
              <span
                v-if="!user.is_deleted"
                class="button is-danger is-small is-rounded"
                @click="softDeleteUser"
                >Delete User</span
              >
              <span
                v-else
                class="button is-success is-small is-rounded"
                @click="softDeleteUser"
                >Undelete User</span
              >
            </div>
          </div>
        </div>

        <!-- <div class="field">
          <label class="label">Driver</label>
          <div class="control has-icons-left">
            <div class="select is-fullwidth is-success">
              <select @change="selectDriver($event)">
                <option disabled selected value>-- Select Driver --</option>
                <option value>** Any Driver **</option>
                <option v-for="d in drivers" :value="d.value" :key="d.key">{{ d.key }}</option>
              </select>
              <span class="icon is-small is-left">
                <i class="fas fa-shuttle-van"></i>
              </span>
            </div>
          </div>
        </div>-->

        <div v-if="t">
          <div class="list" style="margin-bottom: 14px">
            <span class="list-item has-text-left" :style="backgroundStyle(t)">
              <span class="tag icon is-success" v-if="isDriver(t)">
                <i class="fa fa-shuttle-van" />
              </span>
              <span class="tag icon is-link" v-else>
                <i class="fa fa-user" />
              </span>
              <span class="tag" @click="infoToast('Created / Scheduled')">{{
                longScheduledTime(t)
              }}</span>
              <span
                class="tag is-dark"
                :class="stateClass(t)"
                @click="changeState(t)"
                >{{ t.state }}</span
              >
            </span>
          </div>

          <div class="notification is-white">
            <button class="delete is-medium" @click="closeTransaction"></button>
            <p
              class="has-text-danger has-text-weight-medium"
              style="padding-top: 10px; font-size: 1.2em"
            >
              {{ t.workflow_type_name }}
            </p>
            <!-- <p>
              <span
                class="tag has-text-weight-medium has-text-link"
                v-clipboard:copy="t.id"
                v-clipboard:success="onCopy"
              >{{ t.id }}</span>
            </p>
            <br />-->
            <div class="field tags has-addons">
              <span class="single-line">
                <span class="tag is-light is-medium">
                  <i class="fa fa-user" />
                </span>
                <span class="tag is-grey is-medium"
                  >{{ t.customer.name }}&nbsp;({{
                    t.customer.phone_number
                  }})</span
                >
              </span>
            </div>
            <!-- <br /> -->
            <div class="field tags has-addons" v-if="t.driver">
              <span class="single-line">
                <span class="tag is-light is-medium">
                  <i class="fa fa-shuttle-van" />
                </span>
                <span class="tag is-grey is-medium"
                  >{{ t.driver.name }}&nbsp;({{ t.driver.phone_number }})</span
                >
              </span>
            </div>

            <!-- <br /> -->
            <div class="field tags has-addons" v-if="pickupName">
              <span class="single-line">
                <span class="tag is-link is-medium">
                  <i class="fa fa-map-marker-alt" />&nbsp;
                  <span>Pickup</span>
                </span>
                <a class="tag is-grey is-medium">
                  <a :href="pickupMapURL">{{ pickupName }}</a>
                </a>
              </span>
            </div>

            <div class="field tags has-addons" v-if="dropoffName">
              <span class="single-line">
                <span class="tag is-primary is-medium">
                  <i class="fa fa-map-marker-alt" />&nbsp;
                  <span>Dropoff</span>
                </span>
                <span class="tag is-grey is-medium">
                  <a :href="dropoffMapURL">{{ dropoffName }}</a>
                </span>
              </span>
            </div>

            <div class="field tags has-addons">
              <span class="tag is-info is-medium">
                <i class="fa fa-route" />&nbsp;
                <span>Distance</span>
              </span>
              <span class="tag is-grey is-medium">{{ distance }}m</span>
            </div>

            <!-- <div class="columns is-mobile">
            <div class="column" style="max-width:50vw">
              <div class="field">
                <label class="label">Date</label>
                <div class="control has-icons-left">
                  <span class="icon is-small is-left">
                    <i class="fa fa-calendar-alt"></i>
                  </span>
                  <b-field type="is-warning">
                    <b-datepicker v-model="date" placeholder="Today" :min-date="today"></b-datepicker>
                  </b-field>
                </div>
              </div>
            </div>
            <div class="column" style="max-width:50vw">
              <div class="field">
                <label class="label">Time</label>
                <div class="control has-icons-left">
                  <span class="icon is-small is-left">
                    <i class="fas fa-clock" />
                  </span>
                  <b-field type="is-warning">
                    <b-timepicker v-model="time" placeholder="Now" hour-format="24"></b-timepicker>
                  </b-field>
                </div>
              </div>
            </div>
            </div>-->

            <!-- Based on pickup/dropoff should pre-fill cash and tukpay fields -->
            <div class="columns is-mobile">
              <div class="column">
                <div class="field">
                  <label class="label">Cash</label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-warning"
                      v-model="cash"
                      type="number"
                      placeholder="฿30"
                    />
                    <span class="icon is-small is-left">
                      <i class="fab fa-btc"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">TukPay</label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-warning"
                      v-model="tukpay"
                      type="number"
                      placeholder="฿30"
                    />
                    <span class="icon is-small is-left">
                      <i class="fab fa-btc"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">&nbsp;</label>
                  <span
                    class="button is-warning is-rounded"
                    @click="updateTransaction"
                    >Update</span
                  >
                </div>
              </div>
            </div>

            <div style="height: 8px" />
            <div class="field">
              <!-- <div class="control">
                <button
                  class="button is-warning is-fullwidth"
                  @click="updateTransaction"
                >Update Transaction</button>
              </div>
              <br />-->
              <span
                class="tag is-dark is-pulled-right"
                v-clipboard:copy="t.id"
                v-clipboard:success="onCopy"
                >{{ lastFive(t.id) }}</span
              >
              <div class="buttons" v-if="!replicate">
                <button
                  class="button is-info"
                  v-if="isScheduled"
                  @click="replicate = true"
                >
                  Replicate
                </button>
                <button
                  class="button is-danger is-outlined is-small is-rounded"
                  @click="softDelete"
                >
                  <span v-if="!t.is_deleted">Delete</span>
                  <span v-else>Un-Delete</span>
                </button>
              </div>
            </div>
            <div v-if="replicate">
              <b-field label="Replication Dates" type="is-success">
                <b-datepicker
                  :min-date="new Date()"
                  placeholder="Select one or more dates"
                  v-model="replicateDates"
                  multiple
                ></b-datepicker>
              </b-field>
              <div class="field" v-if="replicateDates">
                <div class="control">
                  <button
                    class="button is-warning is-fullwidth"
                    @click="replicateTransactions"
                  >
                    Replicate Transaction
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";

export default {
  name: "EditTransactionForm",
  components: {},
  data() {
    return {
      users: [],
      drivers: [],
      //   passengers: [],
      //   passengerName: "",
      userName: "",
      ID: "", // userID is taken in main
      user: null, // if a user is selected this is user object
      //   selectedPassenger: null,
      selectedDriver: "",
      workflowType: "",
      workflowID: "",
      businessID: "",
      passengerID: "",
      driverID: "",
      cash: null,
      tukpay: null,
      time: null,
      date: null,
      transactions: [],
      t: null, // selected transaction
      roles: [],
      replicate: false,
      replicateDates: null,
      message: null,
      showRoles: false,
      showMessage: false,
      showTransactions: true,
      imgFallback: {
        loading: this.$store.state.menuItemPlaceholderPic, //birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
    };
  },
  computed: {
    qrCodes() {
      return this.roles.filter((r) => r.data.qr_pic_url);
    },
    bankAccounts() {
      return this.roles.filter((r) => r.data.bank_account);
    },
    userHasNotifications() {
      if (this.user.notification_token !== "") return true;
      return false;
    },
    notificationsStyle() {
      var color = "pink";
      if (this.user.notification_token !== "") color = "lightgreen";
      return `background-color:${color}`;
    },
    userCreatedAt() {
      return new Date(this.user.created_at).toISOString().split("T")[0]; // returns date like YYYY-MM-DD
    },
    userUpdatedAt() {
      return new Date(this.user.updated_at).toISOString().split("T")[0]; // returns date like YYYY-MM-DD
    },
    userStateStyle() {
      if (!this.user) return null;
      if (!this.user.is_deleted) return null;
      var color = this.myColor("verylightpink");
      return `background-color: ${color}`;
    },
    pickupName() {
      if (!this.t.data.pickup_stop) return false;
      return this.t.data.pickup_stop.name;
    },
    dropoffName() {
      if (!this.t.data.dropoff_stop) return false;
      return this.t.data.dropoff_stop.name;
    },
    pickupMapURL() {
      var lat = this.t.data.pickup_stop.lat;
      var lon = this.t.data.pickup_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    dropoffMapURL() {
      var lat = this.t.data.dropoff_stop.lat;
      var lon = this.t.data.dropoff_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    distance() {
      if (!this.t.data.fare) return 0;
      return Math.round(this.t.data.fare.distance);
    },
    isScheduled() {
      if (!this.t.data.scheduled_time) return false;
      return true;
    },
  },
  mounted() {
    EventBus.$on("PASTE_SPECIAL_MESSAGE", (txt) =>
      this.pasteSpecialMessage(txt)
    );
  },
  activated() {},
  methods: {
    clearUser() {
      this.userName = "";
      this.ID = "";
      this.t = null;
      this.transactions = [];
      this.roles = [];
      this.users = [];
      this.replicate = false;
      this.replicateDates = null;
      this.message = null;
      this.user = null;
      //   this.passengerID = "";
    },
    editMobile() {
      this.$swal({
        title: "Enter new mobile",
        html: "Thai mobile formats: +66... or 0...",
        // input: "number",
        input: "text",
        showCancelButton: true,
        showCloseButton: true,
        inputValidator: (val) => {
          if (!val || val.length < 8) return "Invalid phone number";
        },
      }).then((val) => {
        if (!val.value) return;
        var phoneNumber = this.parsePhoneNumber(val.value);
        if (!phoneNumber) {
          this.errorToast("Invalid phone number");
          return;
        }
        this.migrateUserAccount(phoneNumber);
      });
    },
    parsePhoneNumber(str) {
      if (str.length < 8) return null;
      if (str[0] === "0") {
        return "+66" + str.substring(1);
      }
      return str;
    },
    migrateUserAccount(phoneNumber) {
      var data = {
        user_id: this.user.id,
        phone_number: phoneNumber,
      };
      var loader = this.loadingDots();
      this.$store
        .dispatch("migrateUserMobile", data)
        .then(() => this.successToast("Account migrated to new mobile"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    copyUserID() {
      this.$copyText(this.user.id);
      this.successToast("Copied user_id");
    },
    copyUUID() {
      this.$copyText(this.user.uuid);
      this.infoToast("Copied uuid");
    },
    specialMessages() {
      this.$swal({
        title: `<span style='font-size:1.1em; position:absolute; left:-40px;'>🧙‍♂️</span><span style='font-size:0.9em'>Special Commands</span>`,
        html: `<div class="psm" style='text-align:left; padding:5px; background-color:#30475e; color:#f2a365'>
        // commands start with a colon <strong style='color:white'>:</strong><br>
        <p onclick='pasteSpecialMessage(":ping")'>:ping</p>
        <p onclick='pasteSpecialMessage(":systemStats")'>:systemStats</>
        <p onclick='pasteSpecialMessage(":goto:profile")'>:goto:profile</p>
        <p onclick='pasteSpecialMessage(":updateRoles")'>:updateRoles</p>
        <p onclick='pasteSpecialMessage(":clearCache")'>:clearCache</p>
        <p onclick='pasteSpecialMessage(":restart")'>:restart</p>
        <br>
        <i style='font-size:0.9em; color:white'>Recipient's app needs to be open. You will get a confirmation reply on success.</i>
        </div>`,
        background: "#222831",
        showCloseButton: true,
        showConfirmButton: false,
        allowEscapeKey: true,
      });
    },
    pasteSpecialMessage(txt) {
      this.message = txt;
      this.$swal.close();
    },
    closeTransaction() {
      this.t = null;
      this.replicateDates = null;
      this.replicate = false;
    },
    changeState(t) {
      alert("changeState", t.state);
      // screate new endpoint for this that can change state without updating timestamp
    },
    isDriver(t) {
      return t.handled_by === this.ID;
    },
    otherPartyName(t) {
      if (this.isDriver(t)) return t.customer.name || t.customer.phone_number;
      if (!t.driver) return "-"; // if no driver
      return t.driver.name || t.driver.phone_number;
    },
    selectUser(u) {
      this.ID = u.value;
      this.userName = u.key;
      console.log("selectUser", u);
      this.users = []; // clear list after selection
      this.getTransactionsForUser();
      this.getRolesForUser();
      this.getUserInfo();
    },
    getMoreTransactions() {
      console.log("getMoreTransactions");
      var payload = { userID: this.ID, offset: this.transactions.length };
      var loader = this.loadingDots();
      this.$store
        .dispatch("getRelevantTransactionsForUser", payload)
        .then((res) => {
          console.log("getMoreTransactions", res);
          if (res.data) this.transactions = this.transactions.concat(res.data);
          else alert("No more transactions");
        })
        .catch((err) => console.error("getRelevantTransactionsForUser", err))
        .finally(() => loader.hide());
    },
    getTransactionsForUser() {
      console.log("getTransactionsForUser");
      var payload = { userID: this.ID, offset: 0 };
      var loader = this.loadingDots();
      this.$store
        .dispatch("getRelevantTransactionsForUser", payload)
        .then((res) => {
          if (res.data) this.transactions = res.data;
          else this.transactions = [];
        })
        .catch((err) => console.error("getRelevantTransactionsForUser", err))
        .finally(() => loader.hide());
    },
    getRolesForUser() {
      this.$store
        .dispatch("getRolesByUserID", this.ID)
        .then((res) => {
          if (res.data) this.roles = res.data;
          else this.roles = [];
        })
        .catch((err) => console.error("getRolesForUser", err));
    },
    getUserInfo() {
      this.$store
        .dispatch("getUserInfo", this.ID)
        .then((res) => {
          console.log("getUserInfo", res);
          this.user = res.data.user;
        })
        .catch((err) => console.error("getRolesForUser", err));
    },
    selectTransaction(t) {
      this.t = t;
      if (t.data.fare) {
        this.cash = t.data.fare.cash;
        this.tukpay = t.data.fare.tukpay;
      }
    },
    // pickupName() {
    //   if (!this.t.data.pickup_stop) return false;
    //   return this.t.data.pickup_stop.name;
    // },
    // dropoffName() {
    //   if (!this.t.data.dropoff_stop) return false;
    //   return this.t.data.dropoff_stop.name;
    // },
    updatedAtInfo() {},
    softDelete() {
      // api should toggle is_deleted flag, so if deleted will un-delete too
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteTransaction", this.t.id)
        .then(() => this.closeTransaction())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    selectPassenger(p) {
      this.passengerID = p.value;
      console.log("selectPassenger", p);
      this.passengerName = p.key;
      this.passengers = [];
    },
    selectBusiness(e) {
      var key = e.target.value;
      var b = this.businesses.find((b) => b.key === key);
      this.businessID = b.business_id;
      this.workflowID = b.workflow_id;
      console.log("selected business", key, b);
      // now fetch business-workflow drivers
      this.$store
        .dispatch("autocompleteDriverWorkflows", b.workflow_id)
        .then((res) => {
          if (res.data) this.drivers = res.data;
          else this.drivers = [];
        })
        .catch((err) => console.error("autocompleteDrivers", err));
    },
    selectDriver(e) {
      this.driverID = e.target.value;
      console.log("selected driver", this.driverID, e);
    },
    stateClass(t) {
      if (t.state === "alighted") return "is-success";
      var cancelled = ["cancelled_by_passenger", "no_show"];
      if (cancelled.includes(t.state)) return "is-warning";
      var active = ["initiated", "confirmed", "driver_arrived", "enroute"];
      if (active.includes(t.state)) return "is-info";
    },
    backgroundStyle(t) {
      if (t.is_deleted) return "background-color: pink"; // might never be used
    },
    roleStyle(r) {
      if (r.is_deleted) return "background-color: pink"; // might never be used
    },
    onCopy(e) {
      this.$swal({
        title: e.text,
        text: "Copied to clipboard!",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast(`Copied ${txt}`, "top");
    },
    lookupUsers(e) {
      var text = e.target.value;
      this.userName = text;
      var search = text;
      if (text[0] === "0") search = text.substring(1);
      console.log("lookupUsers", search);
      if (text.length < 3) {
        this.users = [];
      } else {
        this.$store
          .dispatch("autocompleteUsers", search)
          .then((res) => {
            if (res.data) this.users = res.data;
            else this.users = [];
          })
          .catch((err) => console.error("userAutocomplete", err));
      }
    },
    getFare() {
      if (!this.tukpay) this.tukpay = 0;
      if (!this.cash) this.cash = 0;
      var price = parseInt(this.tukpay) + parseInt(this.cash);
      var discount = parseInt(this.tukpay);
      return {
        version: "v1",
        price: price,
        discount: discount,
        cash: parseInt(this.cash),
        tukpay: parseInt(this.tukpay),
      };
    },
    formCompleted() {
      if (
        // this.driverID === "" ||
        this.passengerID === "" ||
        !this.pickup // || !this.dropoff
      ) {
        this.warningAlert("Please enter passenger and pickup details");
        return false;
      }
      if (this.date && !this.time) {
        this.warningAlert("You must set a time");
        return false;
      }
      return true;
    },
    parseScheduledTime() {
      if (!this.date) {
        return this.time.toISOString(); // time will always be set currently
      }
      // actually could let user not enter and default to NOW, not scheduled
      var dt = this.date;
      dt.setHours(this.time.getHours());
      dt.setMinutes(this.time.getMinutes());
      if (dt < new Date()) {
        alert("Scheduled time cannot be in the past!!");
        return null; // can't be in the past
      }
      return dt.toISOString();
    },
    moreInfo(r) {
      var shortID = this.lastFive(r.id);
      var t = new Date(r.updated_at);
      var timeDiff = Math.round((new Date() - t) / (1000 * 60));
      var prettyTime = `${timeDiff} mins ago`;
      var dataJSON = JSON.stringify(r.data, null, 2);
      if (timeDiff > 60) {
        timeDiff = Math.round(timeDiff / 60);
        prettyTime = `${timeDiff} hours ago`;
      }
      this.$swal({
        title: `<i class='fa fa-user-astronaut fa-2x' style='color:purple' />`,
        html: `<div style="text-align:left">
        Business <strong>${r.business.name}</strong><br>
        Role name <strong>${r.role_name}</strong><br>
        Role ID <strong>${shortID}</strong><br>
        Updated <strong>${prettyTime}</strong><br>
        Data <strong>${dataJSON}</strong></div>`,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: `Delete <i class='fa fa-bomb' style='color:black' />`,
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("info"),
        confirmButtonText: `Edit <i class='fa fa-pencil-alt' style='color:black' />`,
        showCloseButton: true,
      }).then((val) => {
        if (val.value) {
          // EventBus.$emit("ROLE_EDIT_JSON_MODAL", r);
          EventBus.$emit("EDIT_ROLE_MODAL", r);
        }
        if (val.dismiss === "cancel") this.deleteRole(r);
      });
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    deleteRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then((res) => this.console("deleteRole", res))
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.getRolesForUser(); // update roles
        });
    },
    replicateTransactions() {
      var original = new Date(this.t.data.scheduled_time);
      if (Array.isArray(this.replicateDates)) {
        this.replicateDates.forEach((dt) => {
          var diffDays = Math.ceil((dt - original) / (1000 * 60 * 60 * 24));
          var corrected = this.addDays(original, diffDays);
          var date = corrected.toISOString().split("T")[0];
          // var date = dt.toISOString().split("T")[0]; // yyyy-mm-dd
          this.console(`replicate to date: ${date} (${diffDays})`);
          this.replicateSingle(date);
          // hit new endpoint here one-by-one with original transaction_id and new date
          // endpoint should copy over the transaction details and update the date etc.
        });
      } else {
        var date = this.replicateDates.toISOString().split("T")[0]; // yyyy-mm-dd
        this.console("replicate to single:", date);
        this.replicateSingle(date);
      }
    },
    replicateSingle(date) {
      var loader = this.loadingDots("lightblue");
      this.$store
        .dispatch("replicateTransaction", {
          transactionID: this.t.id,
          date: date,
        })
        .then(() => this.closeTransaction())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    updateTransaction() {
      //   if (this.time) {
      //     if (!this.parseScheduledTime()) return; // means error parsing time, don't continue
      //     obj.type = "scheduled";
      //     obj.scheduled_time = this.parseScheduledTime();
      //   }
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: { data: { fare: this.getFare() } },
        })
        .then(() => this.closeTransaction())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    sendMessage(type) {
      if (!this.message) return;
      // ping/pong check
      // if (this.message === "ping") this.message += `:${this.userID()}`;
      var msg = this.message;
      if (this.message[0] === ":") msg = ":" + this.userID() + this.message;
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: this.ID,
          message: msg, //this.message,
          type: type, // send type: sms or push
        })
        .then(() => this.thankYou())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    callPhone() {
      var mobile = this.userName.match(/\(([^)]+)\)/)[1];
      this.console("callPhone", mobile);
      window.location.href = `tel:${mobile}`;
    },
    softDeleteUser() {
      this.$swal({
        title: "Really delete user?!",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Oops... Keep user 😬",
        cancelButtonText: "Destroy user 💣",
        cancelButtonColor: this.bulmaColor("danger"),
      }).then((val) => {
        if (val.dismiss === "cancel") {
          var loader = this.loadingDots("red");
          this.$store
            .dispatch("deleteUser", this.ID)
            .then((res) => console.log("deleteUser", res))
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 1rem;
  padding-top: 0;
}
label.label {
  margin-bottom: 0;
}
.column {
  padding-bottom: 0;
  padding-right: 4px;
}
.list-item {
  padding: 8px 8px;
}
.edit-transaction {
  overflow: auto;
  height: calc(100vh - 60px);
}
.tag {
  padding: 0 6px;
}
.tags {
  margin-bottom: 0;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
}
img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  background-color: lightgoldenrodyellow;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}
.round {
  padding: 5px 9px;
}
.notification.is-white {
  box-shadow: 0 0 2px grey;
}
.field {
  margin-top: 10px;
}
.subtitle {
  /* color: #3273dc; */
  margin-bottom: 4px;
}
strong {
  margin-left: 4px;
}
/* .fa-window-minimize {
  color: rgb(0, 102, 255);
} */
.single-line {
  white-space: nowrap;
  overflow: auto;
}
.bank-transfer {
  padding: 6px;
  background-color: thistle;
  border-radius: 4px;
}
.qr-code {
  width: 100vw;
  height: auto;
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}
.link {
  border-bottom: 1px #ccc dotted;
}
</style>

<style>
/* global for swal button used in magic messages */
.psm p {
  padding: 6px;
  margin-bottom: 2px;
  border: 1px solid #666;
  border-radius: 6px;
}
</style>